import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";
import type { ActionItemRow } from "@/lib/database.types";

export function useActionItems(patientId: string | undefined) {
  return useQuery<ActionItemRow[]>({
    queryKey: ["action_items", patientId],
    enabled: !!patientId,
    queryFn: async () => {
      const { data, error } = await supabase
        .from("action_items")
        .select("*")
        .eq("patient_id", patientId!)
        .is("completed_at", null)
        .order("due_at", { ascending: true, nullsFirst: false });
      if (error) throw error;
      return (data as ActionItemRow[] | null) ?? [];
    },
  });
}
